import e from "react";
import { Box as m } from "../box/index.mjs";
const u = ({ children: t, isError: n, isRequired: o, ...p }) => {
  if (!t)
    throw new Error("InputGroup must have children");
  const i = e.Children.map(t, (r) => e.isValidElement(r) ? e.cloneElement(
    r,
    {
      isError: n,
      isRequired: o
    }
  ) : r);
  return /* @__PURE__ */ e.createElement(m, { position: "relative", ...p }, i);
};
u.displayName = "InputGroup";
export {
  u as InputGroup
};
